import clsx from 'clsx';

import Icon from 'components/Icon';
import Typography from 'components/Typography';
import { getProfileLinkDestination } from 'components/UserSignedInButton/constants';
import { useEventContext } from 'context/EventContext';

import classes from './IconLink.module.scss';

/** @type {import('./types').default} */
const IconLink = ({ link }) => {
  const { event, icon, label } = link;
  const { addEvent } = useEventContext();

  return (
    <button
      type="button"
      className={clsx('IconLink', classes.iconLink)}
      onClick={() => window.location.assign(getProfileLinkDestination(link))}
      {...addEvent(event)}
    >
      {icon && <Icon className={classes.iconLinkIcon} icon={icon} size={20} />}
      <Typography variant="body-sm">{label}</Typography>
    </button>
  );
};

export default IconLink;
